import styled from 'styled-components'
import { theme } from '../../../../styles/theme'

export const Content = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 50px;
`

export const Wrapper = styled.main`
  width: 100%;
  background-color: ${theme.colors.green2};
  padding: 50px 20px;
  height: 100%;
  border-radius: 40px 40px 0px 0px;
  @media (min-width: 768px) {
    width: 30%;
  }
`

export const LogoImage = styled.img`
  max-width: 100%;
  height: auto;
`

export const Header = styled.header`
  button {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    gap: 5px;
    margin: 10px 0 40px 10px;
    color: ${theme.colors.black};
  }
`

export const Section = styled.section`
  color: ${theme.colors.white};
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  margin: 20px 0 25px;
`
